import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Globle } from 'src/assets/globle';
import { Advertize } from '../advertize.model';
import { AdvertizeService } from '../advertize.service';

@Component({
  selector: 'app-advertizelist',
  templateUrl: './advertizelist.component.html',
  styleUrls: ['./advertizelist.component.css'],
  queries: {
    contentRef: new ViewChild("Modal")
  },
})
export class AdvertizelistComponent implements OnInit {

  advertizes: Advertize[] = [];
  displayedColumns: string[] = ['id', 'arabicDescription', 'englishDescription', 'imgUrl', "edit", "delete"];
  dataSource!: MatTableDataSource<Advertize>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  spinnerOverlay = false
  public contentRef!: TemplateRef<any>;
  advertize: Advertize = {} as Advertize;
  Advstatus: { id: number, name: string }[] = [];
  selectedStatus: number = 1
  imagPath: any;
  pageSize = 100;

  constructor(private service: AdvertizeService,
    private router: Router,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private globle: Globle,
    private translate: TranslateService) { }

  ngOnInit() {

    this.Advstatus = [{ id: 1, name: this.translate.instant("active") }, { id: 0, name: this.translate.instant("notActive") }];
    this.selectedStatus = 1;
    this.imagPath = this.globle.imgPath;
    this.pageSize = this.globle.pageSize;
    this.get();
  }

  get() {
    this.spinnerOverlay = true;
    this.service.getAll(this.selectedStatus).subscribe(data => {
      this.advertizes = data.sort((n1, n2) => n2.id - n1.id);
      this.dataSource = new MatTableDataSource(this.advertizes);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  createNew() {
    this.router.navigate(['./master/cards/addadvertize']);
  }

  edit(id: number) {
    this.router.navigate(['./master/cards/editadvertize/' + id]);
  }

  onDelete(id: number) {
    this.advertize.id = id;
    this.openDialog();
  }

  delete() {
    this.spinnerOverlay = true;
    this.dialog.closeAll();
    this.service.Delete(this.advertize.id).subscribe(data => {
      this.openSnackBar(this.translate.instant("deletedSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
      this.get();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        this.dialog.closeAll();
        if (error.error.message) {
          this.openSnackBar(error.error.message, "snackBarError");
        }
        else {
          this.openSnackBar("Internal server error", "snackBarError");
        }
      })
  }

  confirmDelete() {
    this.delete();
  }

  openSnackBar(message: string, cssclass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '300px',
    });
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  selectChange() {
    this.get();
  }

}
